/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M18.161 23.6492c-.4859.4677-1.2726.4677-1.7572 0L6.1279 13.7333c-.9706-.9365-.9706-2.456 0-3.3925L16.4783.3511c.481-.4629 1.2577-.4692 1.7448-.0123.4971.4665.5033 1.2355.0137 1.7092l-9.4731 9.1406c-.486.4689-.486 1.228 0 1.6969l9.3973 9.068c.4859.4677.4859 1.228 0 1.6957Z"
    clipRule="evenodd"
  />,
  'MenuCollapse'
);
